if (!customElements.get('mobile-product-description')) {
  customElements.define('mobile-product-description', class MobileProductDescription extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;

      this.preview = this.querySelector('.mobile-product-description__preview');
      this.full = this.querySelector('.mobile-product-description__full');
      this.toggleButton = this.querySelector('.mobile-product-description__toggle');
      if (!this.preview || !this.full || !this.toggleButton) return;

      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.onChange = () => this.update();
      this.onToggle = () => {
        const wasExpanded = this.expanded;
        this.setExpanded(!wasExpanded);
        if (wasExpanded) this.scrollIntoView({ block: 'start' });
      };
      this.toggleButton.addEventListener('click', this.onToggle);
      this.mobileQuery.addEventListener('change', this.onChange);
      this.frame = requestAnimationFrame(() => this.update());

      if (document.fonts) {
        document.fonts.ready.then(() => {
          if (this.isConnected) this.update();
        });
      }
    }

    disconnectedCallback() {
      this.connected = false;
      cancelAnimationFrame(this.frame);
      this.toggleButton?.removeEventListener('click', this.onToggle);
      this.mobileQuery?.removeEventListener('change', this.onChange);
    }

    setExpanded(expanded) {
      this.expanded = expanded;
      this.preview.hidden = expanded;
      this.full.hidden = !expanded;
      this.toggleButton.textContent = expanded ? 'Show less' : 'Read full description';
      this.toggleButton.setAttribute('aria-expanded', String(expanded));
    }

    update() {
      this.full.hidden = false;
      this.preview.hidden = true;
      const isLong = this.full.getBoundingClientRect().height > 420;
      const shouldShorten = this.mobileQuery.matches && isLong;

      this.toggleButton.hidden = !shouldShorten;
      if (shouldShorten) {
        this.setExpanded(this.expanded === true);
      } else {
        this.expanded = false;
        this.toggleButton.setAttribute('aria-expanded', 'true');
      }
    }
  });
}
